import { TFunction } from "react-i18next";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";

const productNames = [
	"GOPOS_PLAN",
	"GOPOS_ARCHIVE",
	"GOPOS_ADDONS",
	"GOPOS_KDS",
	"GOPOS_KIOSK",
	"GOPOS_TERMINAL",
	"GOPOS_MOBILE_TERMINAL",
	"GOPOS_NUMBER_DISPLAY",
	"GOSTOCK_PLAN",
	"GOSTOCK_IMPORT",
	"GOSTOCK_SUBSTOCK",
	"GOSTOCK_TRANSFER",
	"GOSTOCK_INVENTORY_APP",
	"ADDON_HOTEL",
	"ADDON_PHONE_CENTRAL",
	"MULTILOCATIONS",
	"DRIVERS",
	"EMENU",
	"GOORDER",
	"GOCRM",
	"GOHUB",
	"GOPOS_RENT_TERMINAL",
];

const featureNames = [
	"GOORDER_QRCODE",
	"GOORDER_DELIVERY",
	"GOORDER_DINE_IN",
	"GOORDER_PAY_ORDER",
	"GOHUB_ORDER",
	"GOPOS_MOBILE_WAITER",
	"GOPOS_KIOSK",
	"GOPOS_PAYMENT_OFFLINE",
	"GOPOS_PAYMENT_ONLINE",
	"GOPOS_TIP",
	"GOPOS_KDS",
	"GOPOS_EXTERNAL_DRIVER",
	"GOPOS_DRIVER_APP",
	"GOPOS_RESERVATION",
	"GOCRM_LOYALTY",
];

const partnerTypes = {
	RESELLER: "Reseller",
	KAM: "KAM",
	TOP: "TOP",
	SALE: "Sale",
	CS: "CS",
	CSV: "CSv",
	SALE_PREMIUM: "Sale premium",
	AFFILIATE: "AFFILIATE",
};
const parsePrefix = (id: string, prefix?: string) => {
	return `${prefix ? `${prefix}_` : ""}${id}`;
};
const parseName = (name: string, prefix?: string) => {
	return `${prefix ? `${prefix} - ` : ""}${name}`;
};

class ReportOrganizationFeatureUtils {
	static getOrganizationGroups = (t: TFunction, prefix?: string) => {
		return [
			{
				id: parsePrefix("COMPANY_ID", prefix),
				name: parseName("Company ID", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("NAME", prefix),
				name: parseName("Nazwa", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("PARTNER_CS", prefix),
				name: parseName("Partner CS", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("PARTNER_RESELLER", prefix),
				name: parseName("Partner Reseller", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("PARTNER_KAM", prefix),
				name: parseName("Partner KAM", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("PARTNER_SALE", prefix),
				name: parseName("Partner Sales", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("TAX_ID_NO", prefix),
				name: parseName("NIP", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("FIRST_PAID_DATE", prefix),
				name: parseName("Pierwsza płatność", prefix && "Lokalizacja"),
			},
			{
				id: parsePrefix("PARTNER_TYPE", prefix),
				name: parseName("Typ partnera", prefix && "Lokalizacja"),
			},
		];
	};
	static getOrganizationFilters = (t: TFunction, prefix?: string) => {
		return [
			{
				id: parsePrefix("tax_id_no", prefix),
				name: parseName("NIP", prefix && "Lokalizacja"),
				type: "text",
			},
			{
				id: parsePrefix("company_id", prefix),
				name: parseName("company_id", prefix && "Lokalizacja"),
				type: "text",
			},
			{
				id: parsePrefix("name", prefix),
				name: parseName("Nazwa", prefix && "Lokalizacja"),
				type: "text",
			},
			{
				id: parsePrefix("id", prefix),
				name: parseName("Lokalizacja", prefix && "Lokalizacja"),
				type: "search_select",
				source: {
					request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
						adminApi.getListAdminOrganizationsListSearchSelect(search, params, undefined, {
							cancelToken: options?.token,
						}),
				},
			},
			{
				id: parsePrefix("first_paid_date", prefix),
				name: parseName("Pierwsza płatność", prefix && "Lokalizacja"),
				type: "date",
				extraOptions: ["a", "u"],
			},
			{
				id: parsePrefix("partner_type", prefix),
				name: parseName("Typ partnera", prefix && "Lokalizacja"),
				type: "list",
				options: partnerTypes,
			},
		];
	};

	static getFeatureFilters = (t: TFunction, prefix?: string) => {
		return [
			{
				id: parsePrefix("name", prefix),
				name: parseName("Nazwa funkcji", prefix && "Funkcje"),
				type: "list",
				options: featureNames.reduce((map, type) => {
					map[type] = type;
					return map;
				}, {}),
			},
			{
				id: parsePrefix("product_name", prefix),
				name: parseName("Produkt", prefix && "Funkcje"),
				type: "list",
				options: productNames.reduce((map, type) => {
					map[type] = type;
					return map;
				}, {}),
			},
			{
				id: parsePrefix("sold_by_partner_type", prefix),
				name: parseName("Sprzedaż - typ partnera", prefix && "Funkcje"),
				type: "list",
				options: partnerTypes,
			},
			{
				id: parsePrefix("activated_by_partner_type", prefix),
				name: parseName("Wdrożył - typ partnera", prefix && "Funkcje"),
				type: "list",
				options: partnerTypes,
			},
			{
				id: parsePrefix("activated_by_partner", prefix),
				name: parseName("Wdrożył - Partner", prefix && "Funkcje"),
				type: "search_select",
				extraOptions: ["ne"],
				source: {
					request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
						adminApi.getListAdminPartnersSearchSelect(search, params, {
							cancelToken: options?.token,
						}),
				},
			},
			{
				id: parsePrefix("sold_by_partner", prefix),
				name: parseName("Sprzedaż - Partner", prefix && "Funkcje"),
				type: "search_select",
				extraOptions: ["ne"],
				source: {
					request: (search: string, params: Record<string, any>, options?: Record<string, any>) =>
						adminApi.getListAdminPartnersSearchSelect(search, params, {
							cancelToken: options?.token,
						}),
				},
			},
			{
				id: parsePrefix("first_used_date", prefix),
				name: parseName("Pierwsze użycie", prefix && "Funkcje"),
				type: "date",
				extraOptions: ["a", "u"],
			},
			{
				id: parsePrefix("last_used_date", prefix),
				name: parseName("Ostatnie użycie", prefix && "Funkcje"),
				type: "date",
				extraOptions: ["a", "u"],
			},
			{
				id: parsePrefix("potential", prefix),
				name: parseName("Potencjał  - on/off", prefix && "Funkcje"),
				type: "boolean",
			},
			{
				id: parsePrefix("usage", prefix),
				name: parseName("Używana - on/off", prefix && "Funkcje"),
				type: "boolean",
			},
			{
				id: parsePrefix("usage_value", prefix),
				name: parseName("Ilość użycia", prefix && "Funkcje"),
				type: "number",
			},
			{
				id: parsePrefix("sold_by_partner_at", prefix),
				name: parseName("Sprzedaż - partner data", prefix && "Funkcje"),
				type: "date",
				extraOptions: ["a", "u"],
			},
			{
				id: parsePrefix("enabled_at", prefix),
				name: parseName("Data aktywacji", prefix && "Funkcje"),
				type: "date",
				extraOptions: ["a", "u"],
			},
		];
	};
	static getFeatureGroups = (t: TFunction, prefix?: string) => {
		return [
			{
				id: parsePrefix("FIRST_USED_DATE", prefix),
				name: parseName("Pierwsz użycie", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("LAST_USED_DATE", prefix),
				name: parseName("Ostatnie użycie", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("ENABLED", prefix),
				name: parseName("Włączona - on/off", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("USAGE", prefix),
				name: parseName("Używana - on/off", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("POTENTIAL", prefix),
				name: parseName("Potencjał - on/off", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("NOTES", prefix),
				name: parseName("Notatka", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("NAME", prefix),
				name: parseName("Nazwa funkcji", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("PRODUCT_NAME", prefix),
				name: parseName("Produkt", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("ACTIVATED_BY_PARTNER", prefix),
				name: parseName("Wdrożył - partner", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("SOLD_BY_PARTNER", prefix),
				name: parseName("Sprzedał - partner", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("SOLD_BY_PARTNER_TYPE", prefix),
				name: parseName("Sprzedał - typ partner", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("ACTIVATED_BY_PARTNER_TYPE", prefix),
				name: parseName("Wdrożył - typ partner", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("SOLD_BY_PARTNER_AT", prefix),
				name: parseName("Sprzedał - partner data", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("ENABLED_AT", prefix),
				name: parseName("Data aktywacji", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("SOLD_BY_PARTNER_AT_YEAR_MONTH", prefix),
				name: parseName("Sprzedał - partner Rok/miesiac", prefix && "Funkcje"),
			},
			{
				id: parsePrefix("ENABLED_AT_YEAR_MONTH", prefix),
				name: parseName("Data aktywacji Rok/miesiac", prefix && "Funkcje"),
			},
		];
	};

	static getFeatureUsageFilters = (t: TFunction, prefix?: string) => {
		const name = "F. Usage";
		return [
			{
				id: parsePrefix("name", prefix),
				name: parseName("Nazwa funkcji", prefix && name),
				type: "list",
				options: featureNames.reduce((map, type) => {
					map[type] = type;
					return map;
				}, {}),
			},
			{
				id: parsePrefix("usage_type", prefix),
				name: parseName("Typ użycia", prefix && name),
				type: "list",
				options: {
					MONTHLY: "Miesięczny",
					DAILY: "Dzienny",
				},
			},
			{
				id: parsePrefix("date", prefix),
				name: parseName("Data", prefix && name),
				type: "date",
			},
			{
				id: parsePrefix("product_name", prefix),
				name: parseName("Produkt", prefix && name),
				type: "list",
				options: productNames.reduce((map, type) => {
					map[type] = type;
					return map;
				}, {}),
			},
			{
				id: parsePrefix("usage_month_index", prefix),
				name: parseName("Numer użycia", prefix && name),
				type: "number",
			},
		];
	};
	static getFeatureUsageGroups = (t: TFunction, prefix?: string) => {
		const name = "F. Usage";
		return [
			{
				id: parsePrefix("USAGE_MONTH_INDEX", prefix),
				name: parseName("Numer użycia", prefix && name),
			},
			{
				id: parsePrefix("DATE", prefix),
				name: parseName("Data", prefix && name),
			},
			{
				id: parsePrefix("DATE_YEAR", prefix),
				name: parseName("Data - rok", prefix && name),
			},
			{
				id: parsePrefix("DATE_MONTH", prefix),
				name: parseName("Data - miesiąc", prefix && name),
			},
			{
				id: parsePrefix("DATE_YEAR_MONTH", prefix),
				name: parseName("Data - Rok/miesiac", prefix && name),
			},
			{
				id: parsePrefix("USAGE_TYPE", prefix),
				name: parseName("Typ użycia", prefix && name),
			},
			{
				id: parsePrefix("NAME", prefix),
				name: parseName("Nazwa funkcji", prefix && name),
			},
			{
				id: parsePrefix("PRODUCT_NAME", prefix),
				name: parseName("Produkt", prefix && name),
			},
		];
	};
}

export default ReportOrganizationFeatureUtils;
